module.exports = __webpack_public_path__ + "317891a62923df65cb4fc654414cc85f.png";